<template>
  <div class="video">
    <video
      :id="mediaData.id"
      controls
      playsinline
      controlsList="nodownload nofullscreen"
      oncontextmenu="return false;"
      poster=""
      ref="video"
      @play="onPlay"
    >
      <source :src="mediaData.url" :type="`video/${mediaData.extension}`" />
      <div>
        <span>Формат видео не поддерживается. </span>
        <a :href="mediaData.url">Скачать</a>.
      </div>
    </video>
  </div>
</template>

<script>
import { videoView } from '@/functions/API';

export default {
  name: 'VideoBlock',
  props: {
    mediaData: {
      type: Object,
      required: true,
    },
    postId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      viewTracked: false,
    };
  },
  methods: {
    onPlay() {
      if (this.viewTracked) return;
      this.viewTracked = true;
      videoView(this.postId, this.mediaData.id, (res) => {
        if (res === false) {
          this.viewTracked = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
video {
  display: block;
  width: 100%;
  height: 220px;
  object-fit: cover;
  &::-webkit-media-controls-fullscreen-button {
    display: none;
  }
}
</style>
